// @generated by scripts/gen-capabilities.mjs — DO NOT EDIT.
// Source: capabilities.json (registry version 1, sha256 3850f17a9771600b4a0f7bfa38ccaed8464f3ee391342f5d5b627276e614a8ff).
//
// Canonical single source of truth for TinyCloud capability action URNs (TC-112).
// Regenerate with: node scripts/gen-capabilities.mjs

export const REGISTRY_VERSION = 1 as const;
export const REGISTRY_SOURCE_SHA256 = "3850f17a9771600b4a0f7bfa38ccaed8464f3ee391342f5d5b627276e614a8ff" as const;

/** GitHub repository the registry lives in (TC-121; js-sdk sync anchor). */
export const REGISTRY_SOURCE_REPO = "TinyCloudLabs/tinycloud-node" as const;
/**
 * Git commit the artifact was generated from. Authoritative when generated
 * in CI (GITHUB_SHA); approximate when generated locally, where it names
 * the parent of the commit that will contain this artifact.
 */
export const REGISTRY_SOURCE_GIT_SHA = "e9be8963aef608b2e7cd61df500c84a6104df62a" as const;

export type CapabilityStatus = "active" | "deprecated-alias" | "reserved";

export interface CapabilityEntry {
  urn: string;
  service: string;
  status: CapabilityStatus;
  aliasOf?: string;
  implies?: readonly string[];
}

export const CAPABILITIES: readonly CapabilityEntry[] = [
  { urn: "tinycloud.kv/get", service: "tinycloud.kv", status: "active" },
  { urn: "tinycloud.kv/list", service: "tinycloud.kv", status: "active" },
  { urn: "tinycloud.kv/metadata", service: "tinycloud.kv", status: "active" },
  { urn: "tinycloud.kv/put", service: "tinycloud.kv", status: "active" },
  { urn: "tinycloud.kv/del", service: "tinycloud.kv", status: "active" },
  { urn: "tinycloud.kv/delete", service: "tinycloud.kv", status: "deprecated-alias", aliasOf: "tinycloud.kv/del" },
  { urn: "tinycloud.sql/read", service: "tinycloud.sql", status: "active" },
  { urn: "tinycloud.sql/select", service: "tinycloud.sql", status: "deprecated-alias", aliasOf: "tinycloud.sql/read" },
  { urn: "tinycloud.sql/write", service: "tinycloud.sql", status: "active" },
  { urn: "tinycloud.sql/schema", service: "tinycloud.sql", status: "active" },
  { urn: "tinycloud.sql/admin", service: "tinycloud.sql", status: "active", implies: ["tinycloud.sql/schema"] },
  { urn: "tinycloud.sql/*", service: "tinycloud.sql", status: "active", implies: ["tinycloud.sql/read", "tinycloud.sql/write", "tinycloud.sql/schema", "tinycloud.sql/admin"] },
  { urn: "tinycloud.duckdb/read", service: "tinycloud.duckdb", status: "active" },
  { urn: "tinycloud.duckdb/write", service: "tinycloud.duckdb", status: "active" },
  { urn: "tinycloud.duckdb/admin", service: "tinycloud.duckdb", status: "active" },
  { urn: "tinycloud.duckdb/import", service: "tinycloud.duckdb", status: "active" },
  { urn: "tinycloud.duckdb/export", service: "tinycloud.duckdb", status: "active" },
  { urn: "tinycloud.duckdb/select", service: "tinycloud.duckdb", status: "deprecated-alias", aliasOf: "tinycloud.duckdb/read" },
  { urn: "tinycloud.duckdb/*", service: "tinycloud.duckdb", status: "active", implies: ["tinycloud.duckdb/read", "tinycloud.duckdb/write", "tinycloud.duckdb/admin", "tinycloud.duckdb/import", "tinycloud.duckdb/export"] },
  { urn: "tinycloud.capabilities/read", service: "tinycloud.capabilities", status: "active" },
  { urn: "tinycloud.hooks/subscribe", service: "tinycloud.hooks", status: "active" },
  { urn: "tinycloud.hooks/register", service: "tinycloud.hooks", status: "active" },
  { urn: "tinycloud.hooks/list", service: "tinycloud.hooks", status: "active" },
  { urn: "tinycloud.hooks/unregister", service: "tinycloud.hooks", status: "active" },
  { urn: "tinycloud.encryption/decrypt", service: "tinycloud.encryption", status: "active" },
  { urn: "tinycloud.encryption/network.create", service: "tinycloud.encryption", status: "active" },
  { urn: "tinycloud.encryption/network.revoke", service: "tinycloud.encryption", status: "active" },
  { urn: "tinycloud.space/host", service: "tinycloud.space", status: "active" },
  { urn: "tinycloud.space/create", service: "tinycloud.space", status: "active" },
  { urn: "tinycloud.space/list", service: "tinycloud.space", status: "active" },
  { urn: "tinycloud.space/info", service: "tinycloud.space", status: "active" },
  { urn: "tinycloud.vfs/get", service: "tinycloud.vfs", status: "reserved" },
  { urn: "tinycloud.vfs/list", service: "tinycloud.vfs", status: "reserved" },
  { urn: "tinycloud.vfs/metadata", service: "tinycloud.vfs", status: "reserved" },
  { urn: "tinycloud.vfs/put", service: "tinycloud.vfs", status: "reserved" },
  { urn: "tinycloud.vfs/delete", service: "tinycloud.vfs", status: "reserved" },
] as const;

/// Every action URN accepted at the policy boundary for a service
/// (active, deprecated-alias, and reserved), sorted.
export const ACCEPTED_ACTIONS: Readonly<Record<string, readonly string[]>> = {
  "tinycloud.capabilities": ["tinycloud.capabilities/read"],
  "tinycloud.duckdb": ["tinycloud.duckdb/*", "tinycloud.duckdb/admin", "tinycloud.duckdb/export", "tinycloud.duckdb/import", "tinycloud.duckdb/read", "tinycloud.duckdb/select", "tinycloud.duckdb/write"],
  "tinycloud.encryption": ["tinycloud.encryption/decrypt", "tinycloud.encryption/network.create", "tinycloud.encryption/network.revoke"],
  "tinycloud.hooks": ["tinycloud.hooks/list", "tinycloud.hooks/register", "tinycloud.hooks/subscribe", "tinycloud.hooks/unregister"],
  "tinycloud.kv": ["tinycloud.kv/del", "tinycloud.kv/delete", "tinycloud.kv/get", "tinycloud.kv/list", "tinycloud.kv/metadata", "tinycloud.kv/put"],
  "tinycloud.space": ["tinycloud.space/create", "tinycloud.space/host", "tinycloud.space/info", "tinycloud.space/list"],
  "tinycloud.sql": ["tinycloud.sql/*", "tinycloud.sql/admin", "tinycloud.sql/read", "tinycloud.sql/schema", "tinycloud.sql/select", "tinycloud.sql/write"],
  "tinycloud.vfs": ["tinycloud.vfs/delete", "tinycloud.vfs/get", "tinycloud.vfs/list", "tinycloud.vfs/metadata", "tinycloud.vfs/put"],
};

/// aliasUrn -> canonical URN.
export const ALIASES: Readonly<Record<string, string>> = {
  "tinycloud.duckdb/select": "tinycloud.duckdb/read",
  "tinycloud.kv/delete": "tinycloud.kv/del",
  "tinycloud.sql/select": "tinycloud.sql/read",
};

/// urn -> directly implied URNs.
export const IMPLICATIONS: Readonly<Record<string, readonly string[]>> = {
  "tinycloud.duckdb/*": ["tinycloud.duckdb/admin", "tinycloud.duckdb/export", "tinycloud.duckdb/import", "tinycloud.duckdb/read", "tinycloud.duckdb/write"],
  "tinycloud.sql/*": ["tinycloud.sql/admin", "tinycloud.sql/read", "tinycloud.sql/schema", "tinycloud.sql/write"],
  "tinycloud.sql/admin": ["tinycloud.sql/schema"],
};

/// Resolve a deprecated alias to its canonical URN (single hop).
export function resolveAlias(action: string): string {
  return ALIASES[action] ?? action;
}

/// URNs directly implied by holding `action`.
export function impliedActions(action: string): readonly string[] {
  return IMPLICATIONS[action] ?? [];
}
